import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/layout/header'
import Footer from '../components/layout/footer'
import get from 'lodash/get'
import './index.css'

const Layout = props => {
  const [{ node: footerContent }] = get(props, 'data.allContentfulFooter.edges')
  let isAtRoot = false
  if (
    props.hasOwnProperty('location') &&
    props.location.hasOwnProperty('pathname')
  ) {
    isAtRoot = props.location.pathname === '/'
  }
  return (
    <div>
      <Helmet title={props.data.site.siteMetadata.title} />
      <Header isAtRoot={isAtRoot} />
      <div
        style={{
          minHeight: getMinHeight(),
        }}
      >
        {!isAtRoot && <div style={{ height: getHeight() }} />}
        {props.children()}
      </div>
      <Footer data={footerContent} />
    </div>
  )
}

const getHeight = () => {
  if (typeof window !== 'undefined') {
    if (window.innerWidth < 768) {
      return '3.5rem'
    } else if (window.innerWidth < 992) {
      return '3rem'
    } else {
      return '2.5rem'
    }
  }
}
const getMinHeight = () => {
  if (typeof window !== 'undefined') {
    if (window.innerWidth < 768) {
      return 'calc(100vh - 886.6px)'
    } else if (window.innerWidth < 992) {
      return 'calc(100vh - 192px)'
    } else {
      return 'calc(100vh - 210px)'
    }
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const queries = graphql`
  query SiteDataAndFooterQuery {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulFooter {
      edges {
        node {
          emailGeneralInformation
          emailApplications
          emailStudentMatters
          addressCompany
          addressFaculty
          addressRecipient
          addressStreet
          addressCity
          addressCountry
          sharepointLink {
            url
          }
          eConsortLink {
            url
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js